import { Component } from '@angular/core';
import { LiteNavbar } from '../lite-navbar/lite-navbar';
@Component({
  selector: 'app-lite-hero-section',
  imports: [LiteNavbar],
  templateUrl: './lite-hero-section.html',
  styleUrl: './lite-hero-section.css',
})
export class LiteHeroSection {}
